import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions, mapMutations } from "vuex";
import SegmentHeader from "../headers/segment-header";
import SegmentsNavbar from "./segments-navbar";
import SegmentsEdit from "./segments-edit";
import SegmentsSearch from "./segments-search";
import SegmentsTable from "./segments-table";
import SegmentsTableLoader from "./segments-table-loader";
import SegmentsHeaderLoader from "../headers/segment-header-loader";
import SegmentsNavbarLoader from "./segments-navbar-loader";
import SegmentUnsavedChangesModal from "../modals/segment-unsaved-changes-modal";
import { LOAD_CURRENT_LIST, LOAD_SEGMENT_DATA, UPDATE_SEGMENTS, LOAD_SEGMENT_LIST } from "../../../store/marketing/marketing-actions";
import { DELETE_SEGMENT } from "../../../store/marketing/marketing-mutations";
import Amplitude from "@Shared/@Utils/amplitude";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentsContainer",
  components: {
    SegmentHeader,
    SegmentsNavbar,
    SegmentsEdit,
    SegmentsSearch,
    SegmentsTable,
    SegmentsTableLoader,
    SegmentsHeaderLoader,
    SegmentsNavbarLoader,
    SegmentUnsavedChangesModal
  },
  props: {
    listId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: {
        list: true,
        segments: true,
        changeTabs: false,
        createSegment: false
      },
      currentTab: "all",
      newSegmentId: "",
      currentSegment: {},
      unsavedChanges: false,
      tabToChangeTo: "",
      list: {},
      shouldRefresh: false,
      currentSearchString: "",
      query: "",
      orderBy: "updatedAt",
      orderType: "DESC"
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("MarketingStore", ["currentList", "segments"])), {}, {
    defaultConditionData() {
      return {
        id: 1,
        operator: "=",
        values: [{
          id: 1,
          value: ""
        }]
      };
    },
    segmentAlreadyLoaded() {
      return this.currentList.segmentedLists[this.currentTab];
    },
    currentTabType() {
      if (this.currentTab === "all" || this.currentTab === "add") {
        return this.currentTab;
      }
      return "segment";
    },
    changeTabFunction() {
      return {
        all: this.handleChangeToAll,
        add: this.handleChangeToAdd,
        segment: this.handleChangeToSegment
      };
    }
  }),
  watch: {
    async listId() {
      this.loading.segments = true;
      this.list = {};
      this.currentSegment = {};
      this.currentTab = "all";
      await this.getCurrentList({});
      this.loading.segments = false;
    },
    $route(val) {
      if (val.name === "marketing-list-segments") {
        this.getCurrentList({});
      }
    }
  },
  async mounted() {
    Amplitude.logEvent("Lists - details visited");
    this.loading.segments = true;
    await _Promise.all([this.getCurrentList({})], this.LOAD_SEGMENT_DATA());
    this.loading.segments = false;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("MarketingStore", [LOAD_CURRENT_LIST, LOAD_SEGMENT_DATA, UPDATE_SEGMENTS, LOAD_SEGMENT_LIST])), mapMutations("MarketingStore", [DELETE_SEGMENT])), {}, {
    handleConditionUpdate(data, index) {
      this.unsavedChanges = true;
      const newCond = _objectSpread(_objectSpread({}, this.currentSegment.conditions[index]), data);
      const conditions = cloneDeep(this.currentSegment.conditions);
      conditions[index] = newCond;
      this.$set(this.currentSegment, "conditions", conditions);
    },
    handleConditionDelete(index) {
      this.unsavedChanges = true;
      this.$delete(this.currentSegment.conditions, index);
    },
    handleConditionAdd() {
      this.unsavedChanges = true;
      this.currentSegment.conditions.push(this.defaultConditionData);
    },
    handleToggleJoin(val) {
      this.unsavedChanges = true;
      this.currentSegment.join = val;
    },
    handleChangeName(val) {
      this.unsavedChanges = true;
      this.currentSegment.name = val;
    },
    handleChangeNameAndSubmit(val) {
      var _context;
      const index = _findIndexInstanceProperty(_context = this.currentList.segments).call(_context, elem => elem.id === _parseInt(this.currentTab));
      const updatedSegments = cloneDeep(this.currentList.segments);
      if (updatedSegments[index].name === val) return;
      updatedSegments[index].name = val;
      const data = {
        segments: {
          segments: updatedSegments
        },
        listId: this.listId
      };
      this.handleSubmit(data);
    },
    handleDeleteContacts() {
      this.tabToChangeTo = "all";
      this.handleChangeTab();
      this.getCurrentList({});
    },
    handleSubscribe() {
      this.shouldRefresh = true;
    },
    async handleSearch(query) {
      this.query = query;
      if (this.currentTab === "all") {
        await this.getCurrentList({
          query,
          isSearch: true
        });
      } else {
        await this.getSegment({
          query,
          isSearch: true
        });
      }
    },
    async handlePageChange(offset) {
      if (this.currentTab === "all") {
        await this.getCurrentList({
          offset
        });
      } else {
        await this.getSegment({
          offset
        });
      }
    },
    async handlePageSort(sortParams) {
      this.orderBy = sortParams.orderBy;
      this.orderType = sortParams.orderType;
      if (this.currentTab === "all") {
        await this.getCurrentList({
          query: this.query,
          orderBy: this.orderBy,
          orderType: this.orderType
        });
      } else {
        await this.getSegment({
          query: this.query,
          orderBy: this.orderBy,
          orderType: this.orderType
        });
      }
    },
    handleChangeTabRequest(id) {
      if (this.currentTab === id) return;
      this.tabToChangeTo = id;
      if (this.unsavedChanges) {
        this.$refs.unsavedChangesModalRef.showModal();
      } else {
        this.handleChangeTab();
      }
    },
    async handleChangeTab() {
      this.unsavedChanges = false;
      this.currentTab = this.tabToChangeTo;
      this.changeTabFunction[this.currentTabType]();
      this.shouldRefresh = false;
    },
    handleChangeToAll() {
      if (this.shouldRefresh) {
        this.getCurrentList({});
      } else {
        this.list = this.currentList;
        this.currentSearchString = this.list.searchString;
      }
    },
    async handleChangeToSegment() {
      var _context2;
      this.currentSegment = cloneDeep(_findInstanceProperty(_context2 = this.currentList.segments).call(_context2, elem => elem.id.toString() === this.currentTab));
      if (this.segmentAlreadyLoaded && !this.shouldRefresh) {
        this.list = this.currentList.segmentedLists[this.currentTab];
        this.currentSearchString = this.list.searchString;
      } else {
        this.loading.changeTabs = true;
        await this.getSegment({
          query: "",
          isSearch: true
        });
        this.loading.changeTabs = false;
      }
    },
    handleChangeToAdd() {
      this.currentSegment = {
        conditions: [this.defaultConditionData],
        join: "or",
        name: ""
      };
    },
    async getSegment({
      offset = 0,
      query = "",
      isSearch = false
    }) {
      this.loading.list = true;
      if (!query && !isSearch) {
        query = this.list.searchString ? this.list.searchString : "";
      }
      this.currentSearchString = query;
      await this.LOAD_SEGMENT_LIST({
        listId: this.listId,
        segmentId: this.currentTab,
        offset: offset,
        limit: 10,
        orderBy: this.orderBy,
        orderType: this.orderType,
        searchString: query
      });
      this.list = this.currentList.segmentedLists[this.currentTab];
      this.loading.list = false;
    },
    async getCurrentList({
      offset = 0,
      query = "",
      isSearch = false
    }) {
      this.loading.list = true;
      if (!query && !isSearch) {
        query = this.list.searchString ? this.list.searchString : "";
      }
      this.currentSearchString = query;
      await _Promise.all([this.LOAD_CURRENT_LIST({
        listId: this.listId,
        offset: offset,
        limit: 10,
        orderBy: this.orderBy,
        orderType: this.orderType,
        searchString: query
      })]);
      this.list = this.currentList;
      this.loading.list = false;
    },
    handleFormatSubmit() {
      this.unsavedChanges = false;
      const newSegments = this.currentList.segments ? cloneDeep(this.currentList.segments) : [];
      if (this.currentTab === "add") {
        this.loading.createSegment = true;
        this.currentSegment.id = newSegments.length + 1;
        this.newSegmentId = this.currentSegment.id.toString();
        newSegments.push(cloneDeep(this.currentSegment));
      } else {
        const editIndex = _parseInt(this.currentTab, 10) - 1;
        this.currentSegment.id = _parseInt(this.currentTab, 10);
        newSegments[editIndex] = cloneDeep(this.currentSegment);
      }
      const data = {
        segments: {
          segments: newSegments
        },
        listId: this.listId
      };
      this.handleSubmit(data);
    },
    async handleSubmit(data) {
      this.loading.list = true;
      await this.UPDATE_SEGMENTS(data);
      this.loading.createSegment = false;
      if (this.currentTab === "add") this.currentTab = this.newSegmentId;
      this.getSegment({});
    },
    async handleDeleteCurrentSegment(finishDeleteSegment) {
      if (!this.currentList.segments.length || !this.currentSegment || !this.currentSegment.id) {
        return;
      }
      this.unsavedChanges = false;
      const indexToDelete = this.currentSegment.id - 1;
      this.DELETE_SEGMENT({
        segmentIndex: indexToDelete
      });
      const data = {
        segments: {
          segments: cloneDeep(this.currentList.segments)
        },
        listId: this.listId
      };
      await this.UPDATE_SEGMENTS(data);
      this.tabToChangeTo = "all";
      this.handleChangeTab();
      finishDeleteSegment();
    }
  })
});